export default [
    {
        path: '/ynF97MvJlLY58wQes6Jc',
        children: [
            {
                path: '3dbzxqVMnc',
                name: 'courseRegList',
                meta: {
                    title: ' Courses Registration',
                    authRequired: true,
                    acc: ['y50732'],
                },
                component: () => import('../views/course-registration/list.vue'),
            },
            {
                path: 'U5vqXSoXod',
                name: 'courseRegCreate',
                meta: {
                    title: 'Create Course Registration',
                    authRequired: true,
                    acc: ['y32008'],
                },
                component: () => import('../views/course-registration/create.vue'),
            },
            {
                path: 'cpFg3RyER7LUB4BOfC33/:cr',
                name: 'courseRegView',
                meta: {
                    title: 'View Course Registration',
                    authRequired: true,
                    acc: ['y56956'],
                },
                component: () => import('../views/course-registration/view.vue'),
            },
            {
                path: 'Ou5IaKn2bfDZciCyeM8K/:cr',
                name: 'courseRegUpdate',
                meta: {
                    title: 'Update Course Registration',
                    authRequired: true,
                    acc: ['y76841'],
                },
                component: () => import('../views/course-registration/update.vue'),
            },
            // {
            //     path: 'o0gdOH3p5uXFJDU1ljF0/:cr',
            //     name: 'printcourseReg',
            //     meta: {
            //         title: 'Print Course Registration',
            //         authRequired: true,
            //         acc: ['y56956'],
            //     },
            //     component: () => import('../views/course-registration/print.vue'),

            // }
        ]
    }
]